import React from "react";
import SetupLoadingInfoTable from "./components/SetupLoadingInfoTable";

const SetupLoadingInfo = () => {
  return <SetupLoadingInfoTable />;
};

export default SetupLoadingInfo;
